import { postSeriesSeriesIdFavorite } from "src/api/v2/series/[series_id]/favorite/post"
import { SeriesSeriesIdFavoritePostInputModel } from "src/api/v2/series/[series_id]/favorite/PostInputModel"

export const addFavorite = (seriesId: string): Promise<void> => {
  return postSeriesSeriesIdFavorite(
    new SeriesSeriesIdFavoritePostInputModel(seriesId),
  )
}
